import { render, staticRenderFns } from "./SocialProofBubbleMenu.vue?vue&type=template&id=160c5560&"
import script from "./SocialProofBubbleMenu.vue?vue&type=script&lang=js&"
export * from "./SocialProofBubbleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports